import { useEffect, useRef, useState } from 'react';
import './Contact.css';

function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); obs.disconnect(); }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function Contact() {
  const [ref, inView] = useInView();

  return (
    <section className="contact" id="contact">
      <div ref={ref} className={`contact__inner${inView ? ' is-visible' : ''}`}>
        <p className="section__label">Contact</p>
        <h2 className="contact__title">
          Travaillons <span className="keyword">ensemble</span>
        </h2>
        <p className="contact__sub">
          Un projet, une opportunité, ou juste envie d'échanger ?
        </p>
        <a href="mailto:erenvarli.pro@gmail.com" className="btn btn--primary contact__cta">
          Envoyer un message
        </a>
        <div className="contact__links">
          <a href="https://github.com/ErenVarli" target="_blank" rel="noreferrer" className="contact__social">GitHub</a>
          <a href="https://linkedin.com/in/eren-varli" target="_blank" rel="noreferrer" className="contact__social">LinkedIn</a>
        </div>
      </div>
      <footer className="footer">
        <p>© 2025 Eren Varli.</p>
      </footer>
    </section>
  );
}
